/* eslint-disable no-unused-vars */

import httpClient from './http-client';
import mockSpecialistService from './specialist.service.mock';

let specialistService;

if (process.env.NODE_ENV === 'development') {
  specialistService = mockSpecialistService;
} else {
  specialistService = {
    // params: licType, licActivity, licClass, licStatus, licInst, licNumber, firstname, lastname,
    // personCode, personCountryCode, institutionCode, institutionName, institutionCountryCode, page, pageSize
    getList(params) {
      return httpClient.get('/specialist', { params });
    },

    getById(id) {
      return httpClient.get(`/specialist/${id}`);
    },
  };
}

export default specialistService;
